// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import Reward from '../component/Reward';

class DetailContainer extends React.Component {
    constructor(props: Record<string, unknown>) {
        super(props);
        this.state = {};
    }

    render() {
        return <Reward />;
    }
}

const mapStateToProps = (state: { verify: unknown }) => {
    return {
        verify: state.verify,
    };
};

export default compose(connect(mapStateToProps), withRouter)(DetailContainer);
